var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTealChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "6px",
    viewBox: "0 0 9 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Teal Caret") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.08088075,0.181394512 C0.827237356,-0.0668174586 0.423338804,-0.0593701686 0.178748084,0.198028502 C-0.0658426358,0.455427172 -0.0585039958,0.865305582 0.195139394,1.11351754 L4.16666666,5 L8.13819393,1.11351754 C8.39183732,0.865305582 8.39917596,0.455427172 8.15458524,0.198028502 C7.90999452,-0.0593701686 7.50609597,-0.0668174586 7.25245257,0.181394512 L4.16666666,3.20110254 L1.08088075,0.181394512 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teal-Caret",
    transform: "translate(4.666667, 3.333333) rotate(180.000000) translate(-4.666667, -3.333333) translate(0.500000, 0.833333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.833333, -2.500000)",
    id: "Color/UI/Slate/Slate-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)",
    id: "Group",
    fill: "#2F899C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTealChevron);
export default __webpack_public_path__ + "static/media/teal-chevron.c38b91de5b1d7cc6f3d9af5c018eb7b9.svg";
export { ForwardRef as ReactComponent };